import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import BackupUserComponent from "../../components/BackupUser";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import { setLanguage } from "redux-i18n";
import { useParams, useLocation } from "react-router-dom";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const UserForm = (props, context) => {

    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const userAuthReducer = useSelector((state) => state.userAuthReducer);


    const dispatch = useDispatch();
    const modalAction = bindActionCreators(modalActions, dispatch);
    const commonAction = bindActionCreators(commonActions, dispatch);
    const userAuthAction = bindActionCreators(userAuthActions, dispatch);

    // const [formData, setFormData] = useState({});
    // const [isPasswordFiedShown,setIsPasswordFiedShown] = useState(true);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }


    const query = useQuery();
    // ;

    // useEffect(() => {
    //     // userAuthAction.getAuthUserRoles();
    //     if (query.get("authUserId")) {
    //         setIsPasswordFiedShown(false);
    //         userAuthAction.getAuthUserById(query.get("authUserId"));
    //     }
    // }, [query.get("authUserId")]);

    // useEffect(() => {
    //     // userAuthAction.getAuthUserRoles();
    //     if (userAuthReducer.isUserSet) {
    //         setFormData(userAuthReducer.authUser);
    //         userAuthAction.resetIsUserSet();
    //     }
    // }, [userAuthReducer.isUserSet]);


    const getAllCompanyList = () => userAuthAction.getAllCompanyList();


    //for open modal
    const openSetModal = (children, size) => {
        modalAction.openSetModal(children, size);
    };

    //for closing modal
    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };

    //for changing language
    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const resetSelectedCompany = (companyInfo) => userAuthAction.resetSelectedCompany(companyInfo);

    const resetAllAuthUsersAndBackupUser = () => userAuthAction.resetAllAuthUsersAndBackupUser();

    const resetAuthUser = () => userAuthAction.resetAuthUser();

    const getAuthUserById = (authUserId) => {
        userAuthAction.getAuthUserById(authUserId);
    }

    const getAllAuthUsers = (companyId) => {
        const payload = {
            "request": {
                "companyId": companyId,
                "pagination": {
                    "pageNo": 0,
                    "pageSize": 0,
                    "sortColumn": null,
                    "sortOrder": null,
                    "searchColumn": null,
                    "searchValue": null
                }
            }
        }
        userAuthAction.getAllAuthUsers(companyId, payload, false);
    }

    const resetIsUserSet = () => userAuthAction.resetIsUserSet();

    const getBackupUsers = (departmentId) => userAuthAction.getBackupUsers(departmentId);

    const handleSubmit = (payload) => {
        let isDelete = payload.isDelete;
        let newPayload = payload;
        delete newPayload["isDelete"];
        !isDelete ? userAuthAction.saveBackupUser(newPayload) : userAuthAction.deleteBackupUser(newPayload) 
    }


    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <ShowForPermission module={PERMISSON_MODULES.BACKUP_USER} permission={PERMISSION_TYPE.VIEW}>
                    <BackupUserComponent
                        profileReducer={profileReducer}
                        userAuthReducer={userAuthReducer}
                        getAllCompanyList={getAllCompanyList}
                        resetSelectedCompany={resetSelectedCompany}
                        roleId={profileReducer.managersDetails.roleId}
                        getAllAuthUsers={getAllAuthUsers}
                        getAuthUserById={getAuthUserById}
                        resetIsUserSet={resetIsUserSet}
                        getBackupUsers={getBackupUsers}
                        handleSubmit={handleSubmit}
                        resetAllAuthUsersAndBackupUser={resetAllAuthUsersAndBackupUser}
                        resetAuthUser={resetAuthUser}
                        context={context}
                    />
                </ShowForPermission>
            </div>
        </>
    );
};

UserForm.contextTypes = {
    t: PropTypes.func.isRequired,
};
export default UserForm;
